<template>
<div>
	<h1 class="heading">Про додаток</h1>
	<p>знайомство з проектом і його розробниками</p>
	<div class="underscore"></div>

		<!--<a href="static/plan.html" class="menu__item bordered">
			<p>Налаштування<br><span class="menu__item__description">загальні налаштування додатку</span>
			<img class="menu__item__arrow" src="static/right.svg">
			</p>
		</a>-->

	<!--<div class="menu__item bordered" style="margin-top: -10px;" >
		<p style="color: #000201; font-size: 16px; font-weight: 600">Створено з <span style="color: red;">❤</span> за допомогою Vue-cli, Axios та Apache Cordova</p>
	</div>-->
   
    <div class="info_project">Ідея створення додатку прийшла в серпні 2018-го року для участі в <a href="https://startup.mnau.edu.ua/" target="_blank" style="color: #283662;">конкурсі стартап проектів Миколаївського НАУ</a>. Після обговорення командою майбутнього функціоналу було вирішено також подати заявку на <a href="https://mon.gov.ua/ua/2019-rik-festival-innovacij" target="_blank" style="color: #283662;">Всеукраїнський фестиваль інновацій 2019</a> від Міністерства освіти і науки. Надіславши деякі матеріали, проект було прийнято до півфіналу, і через деякий час прийшло повідомлення, що ми стали однією з 90 відібраних команд, які потрапили до фіналу. На заході було продемонстровано демо-версію додатку, що зацікавила деяких відвідувачів фестивалю. Наразі, функціонує бета версія<br>
    <p></p>«Літачок» – додаток, який містить корисну довідкову та прикладну інформацію для здобувачів вищої освіти за економічними напрямами підготовки та практикуючих бухгалтерів, економістів та інших фахівців. Проект розроблений за співпраці <a href="https://www.mnau.edu.ua/faculty-off/kaf-ist/" target="_blank" style="color: #283662;">кафедри інформаційних систем і технологій</a> та <a href="https://www.mnau.edu.ua/faculty-off/kaf-oblik/" target="_blank" style="color: #283662;">кафедри обліку і оподаткування</a> Миколаївського НАУ</div>

    
    <div class="info_developer">
        <div class="icon_developer">
		<svg  aria-hidden="true" focusable="false" data-prefix="far" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 dev_svg" role="img" xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 496 512">
			<path fill="#435075" d="M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"></path>
		</svg>
		<div class="info_developer_heading" style="color: #435075">Буганов Олег
     	</div>
     	<div class="info_developer_description" style="margin-bottom: 8px; color: #435075">засновник, арт-директор</div>
     		<a href="https://www.instagram.com/perhapsdesigner/" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram" class="svg-inline--fa fa-instagram fa-w-14" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#435075" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
     		</a>
     		<a href="https://t.me/perhapsdesigner" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="telegram-plane" class="svg-inline--fa fa-telegram-plane fa-w-14" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#435075" d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>
     		</a>
     		<a href="https://www.facebook.com/perhapsdesigner" style="color: white;" class="link_developer">
     			<svg viewBox="0 0 24 24" width="20px" height="20px"><path fill="#435075" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
     			</svg>
     		</a>
     		<a href="mailto:perhapsdesigner@gmail.com" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#435075" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path></svg>
     		</a>

     	
    </div>
    </div>

    <div class="info_developer">
        <div class="icon_developer">
		<svg  aria-hidden="true" focusable="false" data-prefix="far" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 dev_svg" role="img" xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 496 512">
			<path fill="#435075" d="M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"></path>
		</svg>
		<div class="info_developer_heading" style="color: #435075">Ендрес Віталій
     	</div>
     	<div class="info_developer_description" style="margin-bottom: 8px; color: #435075" >фронтенд-розробник</div>
     		<a href="https://www.instagram.com/vitaly.andres/" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram" class="svg-inline--fa fa-instagram fa-w-14" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#435075" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
     		</a>
     		<a href="https://t.me/vitaly_andres" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="telegram-plane" class="svg-inline--fa fa-telegram-plane fa-w-14" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#435075" d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>
     		</a>
     		<a href="https://www.facebook.com/vitalyandres98" style="color: white;" class="link_developer">
     			<svg viewBox="0 0 24 24" width="21px" height="21px"><path fill="#435075" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
     			</svg>
     		</a>
     		<a href="mailto:andres@mnau.edu.ua" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#435075" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path></svg>
     		</a>

     	
    </div>
    </div>

    <div class="info_developer">
        <div class="icon_developer">
		<svg  aria-hidden="true" focusable="false" data-prefix="far" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16 dev_svg" role="img" xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 496 512">
			<path fill="#435075" d="M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"></path>
		</svg>
		<div class="info_developer_heading" style="color: #435075">Волосюк Юрій
     	</div>
     	<div class="info_developer_description" style="margin-bottom: 8px; color: #435075" >ком'юніті-менеджер</div>
     		<a href="mailto:volosyuk@mnau.edu.ua" style="color: white;" class="link_developer">
     			<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#435075" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path></svg>
     		</a>

     	
    </div>
    </div>


    <a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" target="_blank" href="https://t.me/litachokveb">
	<div class="menu__item bordered">
	<div class="icon_svg">
		<svg aria-hidden="true" data-prefix="fab" data-icon="telegram-plane" width="25px" height="25px" class="svg-inline--fa fa-telegram-plane fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			<path fill="#435075" d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path>
		</svg>
	</div>
		<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Telegram<br />
			<span style="font-size: 14px;" class="menu__item__description">дізнавайтесь про оновлення</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
		</p>
	</div>
	</a>

	<a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" target="_blank" href="https://www.instagram.com/litachokveb">
	<div class="menu__item bordered">
	<div class="icon_svg">
		<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"  width="25" height="25" viewBox="0 0 24 24">
			<path fill="#435075" d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"></path>
		</svg>
	</div>
		<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Instagram<br />
			<span style="color: #636867; font-size: 14px;" class="menu__item__description">ближче до Вас</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
		</p>
	</div>
	</a>

	<a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" target="_blank" href="https://www.facebook.com/litachokveb">
	<div class="menu__item bordered">
	<div class="icon_svg">
		<svg viewBox="0 0 24 24" width="25px" height="25px"><path fill="#435075" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" />
     	</svg>
	</div>
		<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Facebook<br />
			<span style="color: #636867; font-size: 14px;" class="menu__item__description">розповідаємо про додаток</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
		</p>
	</div>
	</a>

	<a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" target="_blank" href="mailto:litachokveb@gmail.com">
	<div class="menu__item bordered">
	<div class="icon_svg">

		<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#435075" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path></svg>
	</div>
		<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Пошта<br />
			<span style="color: #636867; font-size: 14px;" class="menu__item__description">з питань співпраці</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
		</p>
	</div>
	</a>

	<a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" target="_blank" href="https://t.me/litachokveb_support">
	<div class="menu__item bordered">
	<div class="icon_svg">
		<svg aria-hidden="true" data-prefix="fas" data-icon="bug" class="svg-inline--fa fa-bug fa-w-16" role="img" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path fill="#435075" d="M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"></path>
		</svg>
	</div>
		<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Виявили помилку? <br />
			<span style="color: #636867; font-size: 14px;" class="menu__item__description">повідомте нам про неї</span>
			<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
		</p>
	</div>
    </a>

    <a style="display: flex; flex-direction: row; align-items: center; text-decoration: none;" href="static/updates.html" title="Поточна версія">
    <div class="menu__item bordered">
    <div class="icon_svg">
    	<svg aria-hidden="true" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 512 512">
    		<path fill="#435075" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path>
    	</svg>
    </div>
    	<p style="font-size: 16px; font-weight: 600; padding-left: 15px;">Litachok<br />
    		<span style="color: #636867; font-size: 14px;" class="menu__item__description">0.1 </span>
    		<img class="menu__item__arrow" src="https://litachok.mnau.edu.ua/home/static/img/right.svg">
    	</p>
    </div>
    </a>

</div>
</template>
<script>
export default {
	data () {
		return {
			}
		}
	
}
</script>
<style>
	
</style>
<style scoped>
	.menu__item {
	// padding: 5px 10px;
	width: 100%;
	margin: 10px auto 15px;
	box-sizing: border-box;
	}
	.wrap {
	}
	.wrap>p {
		color: #000201;
		font-size: 16px;
		margin: 0;
		min-width: 70px;
		font-weight: 600;
	}
	.menu__item p.name {
		color: #636867;
		font-size: 13px;
		margin: 3px 0 15px;
		font-weight: 600;
	}
	.menu__item ul li {
		color: #636867;
		font-size: 14px;
	}
	.menu__item ul {
		padding-left: 17px;
	}
	.cab {
		text-align: right;
		color: #636867 !important;
		font-size: 14px !important;
		font-weight: 600;
	}

	  .underscore {
  height: 4px;
  width: 50px;
  background-color: #EEC03A;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  border-radius: 2px;
}
    h1 + p {
      text-align: center;
      color: grey;
      font-size: 12px;
      margin-top: -10px;
    }

	.icon_svg {
		margin-top: 23px;
	}

	.link_developer {
		padding-top: 5px;
     	margin-right: 3px;
	}

	.info_project {
		margin: 0px 0px 15px 0px;
		/*background-color: #435075;*/
		/*border-radius: 10px;*/
		color: #242627;
		/*padding: 20px 20px 20px 20px;*/
		font-size: 13px;
		font-weight: lighter;
		line-height: 1.5;
	}

	.info_developer {
		margin-bottom: 0px;
		background-color: #E2E7FA;
		border-radius: 10px;
		color: white;
		padding: 8px 8px 8px 12px;
		margin-top: 5px;
	}


	.info_developer_heading {
		font-size: 16px;
		font-weight: bolder;
	}

	.info_developer_description {
		font-size: 14px;
		font-weight: lighter;
	}

	.icon_developer {
		margin-top: 0px;
        margin-right: 20px;
	}	
	.icon_developer svg.dev_svg {
		float: left;
		margin-top: 5px;
		margin-right: 12px;
	}

	.icon_developer_svg {
		fill: green;
	}

		.bordered {
	background-color: #eee;
	padding: 1px 15px;
	border-bottom: solid 0px #eee;
	border-radius: 10px;
	transition: 0.4s;
	overflow: hidden;
	font-size: 14px;
	color: #343637;
	margin-top: 5px;
	margin-bottom: 0px;
	}

.active, .bordered:hover {
 	background-color: #E2E7FA; 
 	color: #283662;
}

	.cab::before {
		content: " ";
		color: ;
	}

		a {
		text-decoration: none;
		color: black;
	}

</style>
<style scoped>
	html {
box-sizing: border-box;
}
*,
*:before,
*:after {
/* box-sizing: content-box;*/
}
body {
font-size: 16px;
}
.toast {
position: fixed;
bottom: 0;
left: 0;
right: 0;
width: 100vw;
height: 52px;
background-color: #323232;
padding: 0px 23px;
color: white;
z-index: 999;
box-sizing: border-box;
transition: all 0.4s ease-in-out;
transform: translateY(52px);
}
.active {
	transform: translateY(0px);
}
.toast>p>a{
	position: absolute;
right: 25px;
text-decoration: none;
color: #28ac84;
font-weight: 600;
}
.ig-control {
margin: 10px 0;
-webkit-tap-highlight-color: transparent;
-webkit-touch-callout: none;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
}
.ig-control__radio:not(:checked),
.ig-control__radio:checked {
opacity: 0;
position: absolute;
/* margin: 0; */
z-index: 5;
width: 85%;
height: 22px;
margin-top: 0px;
}
.ig-control__radio ~ label {
display: inline-block;
position: relative;
cursor: pointer;
height: 20px;
line-height: 20px;
font-size: 16px;
font-weight: 600;
color: #484848;
padding-left: 26px;
}
.ig-control__radio ~ label:before,
.ig-control__radio ~ label:after {
position: absolute;
content: '';
width: 15px;
height: 15px;
left: 0;
border: 2px solid transparent;
border-radius: 50% 50%;
}
.ig-control__radio ~ label:before {
backface-visibility: hidden;
transform: translateZ(0);
transition: all .2s ease-in;
}
.ig-control__radio:not(:checked) ~ label:before {
transform: scale(0);
}
.ig-control__radio:not(:checked) ~ label:after {
border: 2px solid #757575;
}
.ig-control__radio:checked ~ label:before {
border: 2px solid #0375BE;
background-color: #0375BE;
transform: scale(0.5);
}
.ig-control__radio:checked ~ label:after {
border: 2px solid #0375BE;
}
.ig-control__radio:disabled ~ label {
pointer-events: none;
color: #D1D1D1;
}
.ig-control__radio:disabled:not(:checked) ~ label:after {
border: 2px solid #D1D1D1;
}
.ig-control__radio:disabled:checked ~ label:before {
background-color: #D1D1D1;
border: 2px solid #D1D1D1;
}
.ig-control__radio:disabled:checked ~ label:after {
border: 2px solid #D1D1D1;
}
</style>
<style scoped>
	a {
		text-decoration: none;
		color: black;
	}
</style>




// WEBPACK FOOTER //
// src/Author.vue